import React, { useState, useRef } from "react";
import { Stack, Typography, styled } from "@mui/material";

interface InputCodeInterface {
  length: number;
  label: string;
  loading: any;
  onComplete: (code: string) => void;
}

const CodeInput = styled("input")(({ theme }: any) => ({
  border: "none",
  backgroundImage: "none",
  backgroundColor: "transparent",
  boxShadow: "none",
  textAlign: "center",
  height: "60px",
  minWidth: "60px",
  width: "100%",
  borderRadius: "0px",
  margin: "0 4px",
  borderBottom: `2px solid ${theme.palette.common.borderGrey}`,
  fontSize: "38px",
  outline: "none",
}));

const InputCode = ({
  length,
  label,
  loading,
  onComplete,
}: InputCodeInterface) => {
  const [code, setCode] = useState([...Array(length)].map(() => ""));
  const inputs = useRef<(HTMLInputElement | null)[]>([]);

  const processInput = (
    e: React.ChangeEvent<HTMLInputElement>,
    slot: number
  ) => {
    const num = e.target.value;
    if (/[^0-9]/.test(num)) return;
    const newCode = [...code];
    newCode[slot] = num;
    setCode(newCode);
    if (slot !== length - 1) {
      inputs?.current[slot + 1]?.focus();
    }
    if (newCode.every((num) => num !== "")) {
      onComplete(newCode.join(""));
    }
  };

  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>, slot: number) => {
    if (e.keyCode === 8 && !code[slot] && slot !== 0) {
      const newCode = [...code];
      newCode[slot - 1] = "";
      setCode(newCode);
      inputs?.current[slot - 1]?.focus();
    }
  };

  return (
    <Stack alignItems="start" spacing={0.5} width="100%">
      <Typography variant="h5">{label}</Typography>
      <Stack direction="row" alignItems="start">
        {code.map((num, idx) => {
          return (
            <CodeInput
              key={idx}
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={num}
              autoFocus={!code[0].length && idx === 0}
              readOnly={loading}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                processInput(e, idx)
              }
              onKeyUp={(e) => onKeyUp(e, idx)}
              ref={(ref) => inputs.current.push(ref)}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};

export default InputCode;
